
// Loads the full DPDP Act and DPDP Rules content from JSON files

import dpdpActData from '../static/dpdp-act.json';
import dpdpRulesData from '../static/dpdp-rules.json';

export const RawLaw = {
  list: () => [
    dpdpRulesData,
    dpdpActData
  ]
};
function stripMarkdownLinks(text) {
  if (typeof text !== 'string') return text;
  return text
    .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
    .replace(/\n\n/g, '')
    .replace(/\n\n/g, '')
    .replace(/←[^→\n]*→?/g, '')
    .replace(/←[^→\n]*$/g, '')
    .replace(/→[^←\n]*$/g, '');
}

function cleanData(rawData) {
  const cleaned = JSON.parse(JSON.stringify(rawData));
  
  if (cleaned.chapters) {
    cleaned.chapters.forEach(chapter => {
      if (chapter.articles) {
        chapter.articles.forEach(article => {
                                        if (article.content) {
                                                    // Replace n (with optional spaces) followed by a number and dot, not preceded by a digit or dot
                                                    article.content = article.content.replace(/(^|[^\d\.])n\s*(\d+)\./g, '$1\n\n$2.');
                                                    // Remove stray 'n' or 'n n n' at the end or between sections
                                                    article.content = article.content.replace(/(\s|\n)n(\s|\n)/g, '$1$2');
                                                    article.content = article.content.replace(/(\s|\n)n+$/g, '');
                                                    // Clean up excessive newlines
                                                    article.content = article.content.replace(/\n\n\n+/g, '\n\n');
                                                    // Remove everything from "## Suitable Recitals" onwards
                                                    article.content = article.content.replace(/## Suitable Recitals[\s\S]*$/g, '');
                                                    // Clean markdown links and other formatting
                                                    article.content = stripMarkdownLinks(article.content);
                                                    article.content = article.content.trim();
                                        }
          if (article.recitals) {
            // Recitals are already parsed, no need to convert \n
            article.recitals = stripMarkdownLinks(article.recitals);
            article.recitals = article.recitals.trim();
          }
          if (article.title) {
            article.title = stripMarkdownLinks(article.title);
          }
          delete article.source;
        });
      }
    });
  }
  
  return cleaned;
}

export const Law = {
  list: () => cleanData(RawLaw.list())
};
